// extracted by mini-css-extract-plugin
export default {"root":"BeamSettingsForm_root__EqkY9","actions":"BeamSettingsForm_actions__qfhVj"};